var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 47,
    viewBox: "0 0 82 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00013 42.1372L16.4961 42.1372C19.1678 42.1372 20.7297 40.3698 21.3052 38.7051C21.8806 37.0404 21.7573 34.6975 19.6611 33.0328L17.3387 31.1832C14.3587 28.8197 13.2489 24.9766 14.5026 21.38C15.7562 17.7835 19.024 15.4817 22.8055 15.4817L29.2998 15.4817L29.2998 19.181L22.8055 19.181C20.1338 19.181 18.5718 20.9484 17.9964 22.6131C17.4209 24.2778 17.5442 26.6207 19.6405 28.2854L21.9629 30.135C24.9428 32.4985 26.0526 36.3417 24.799 39.9382C23.5453 43.5347 20.2776 45.8365 16.4961 45.8365L1.00013 45.8365",
    stroke: "#000",
    className: "stroke",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8677 33.1767L60.8677 1.50659L56.3258 1.50659L56.3258 33.1767L60.8677 33.1767Z",
    stroke: "#000",
    className: "stroke",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6025 18.9961L34.6026 15.7078C34.6026 7.87761 40.953 1.50659 48.8038 1.50659L56.3257 1.50659L56.3257 33.1767L48.8038 33.1767C40.953 33.1767 34.6025 26.8263 34.6025 18.9961Z",
    stroke: "#000",
    className: "stroke",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3002 20.0854L29.3002 17.352L29.3002 14.5981L34.582 14.5981L34.582 20.0854L29.3002 20.0854Z",
    stroke: "#000",
    className: "stroke",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5483 12.8924L76.5483 7.89832L60.8674 7.89831L60.8674 12.8924L76.5483 12.8924Z",
    stroke: "#000",
    className: "stroke",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5472 12.9132L76.5472 7.89862L78.0886 7.89862C79.3012 7.89862 80.2671 8.8851 80.2671 10.0771L80.2671 10.7348C80.2671 11.9268 79.3012 12.9132 78.0886 12.9132L76.5472 12.9132Z",
    stroke: "#000",
    className: "stroke",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5488 26.7852L76.5488 21.7911L60.8679 21.7911L60.8679 26.7852L76.5488 26.7852Z",
    stroke: "#000",
    className: "stroke",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5487 26.7854L76.5487 21.7914L78.0901 21.7914C79.2821 21.7914 80.2686 22.7573 80.2686 23.9699L80.2686 24.6275C80.2686 25.8195 79.3026 26.806 78.0901 26.806L76.5487 26.806L76.5487 26.7854Z",
    stroke: "#000",
    className: "stroke",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.fb172cac.svg";
export { ForwardRef as ReactComponent };